/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createRasterCategory } from '../fn/raster-category-controller/create-raster-category';
import { CreateRasterCategory$Params } from '../fn/raster-category-controller/create-raster-category';
import { deleteRasterCategory } from '../fn/raster-category-controller/delete-raster-category';
import { DeleteRasterCategory$Params } from '../fn/raster-category-controller/delete-raster-category';
import { getRasterCategories } from '../fn/raster-category-controller/get-raster-categories';
import { GetRasterCategories$Params } from '../fn/raster-category-controller/get-raster-categories';
import { getRasterCategoriesFiltered } from '../fn/raster-category-controller/get-raster-categories-filtered';
import { GetRasterCategoriesFiltered$Params } from '../fn/raster-category-controller/get-raster-categories-filtered';
import { getRasterCategory } from '../fn/raster-category-controller/get-raster-category';
import { GetRasterCategory$Params } from '../fn/raster-category-controller/get-raster-category';
import { PageRasterCategoryDto } from '../models/page-raster-category-dto';
import { RasterCategoryDto } from '../models/raster-category-dto';
import { updateRasterCategory } from '../fn/raster-category-controller/update-raster-category';
import { UpdateRasterCategory$Params } from '../fn/raster-category-controller/update-raster-category';

@Injectable({ providedIn: 'root' })
export class RasterCategoryControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getRasterCategory()` */
  static readonly GetRasterCategoryPath = '/v1/rastercategory/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRasterCategory()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRasterCategory$Response(params: GetRasterCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<RasterCategoryDto>> {
    return getRasterCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRasterCategory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRasterCategory(params: GetRasterCategory$Params, context?: HttpContext): Observable<RasterCategoryDto> {
    return this.getRasterCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<RasterCategoryDto>): RasterCategoryDto => r.body)
    );
  }

  /** Path part for operation `updateRasterCategory()` */
  static readonly UpdateRasterCategoryPath = '/v1/rastercategory/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateRasterCategory()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateRasterCategory$Response(params: UpdateRasterCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<RasterCategoryDto>> {
    return updateRasterCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateRasterCategory$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateRasterCategory(params: UpdateRasterCategory$Params, context?: HttpContext): Observable<RasterCategoryDto> {
    return this.updateRasterCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<RasterCategoryDto>): RasterCategoryDto => r.body)
    );
  }

  /** Path part for operation `deleteRasterCategory()` */
  static readonly DeleteRasterCategoryPath = '/v1/rastercategory/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteRasterCategory()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteRasterCategory$Response(params: DeleteRasterCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteRasterCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteRasterCategory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteRasterCategory(params: DeleteRasterCategory$Params, context?: HttpContext): Observable<void> {
    return this.deleteRasterCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getRasterCategories()` */
  static readonly GetRasterCategoriesPath = '/v1/rastercategory';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRasterCategories()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRasterCategories$Response(params?: GetRasterCategories$Params, context?: HttpContext): Observable<StrictHttpResponse<PageRasterCategoryDto>> {
    return getRasterCategories(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRasterCategories$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRasterCategories(params?: GetRasterCategories$Params, context?: HttpContext): Observable<PageRasterCategoryDto> {
    return this.getRasterCategories$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageRasterCategoryDto>): PageRasterCategoryDto => r.body)
    );
  }

  /** Path part for operation `createRasterCategory()` */
  static readonly CreateRasterCategoryPath = '/v1/rastercategory';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createRasterCategory()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createRasterCategory$Response(params: CreateRasterCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<RasterCategoryDto>> {
    return createRasterCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createRasterCategory$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createRasterCategory(params: CreateRasterCategory$Params, context?: HttpContext): Observable<RasterCategoryDto> {
    return this.createRasterCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<RasterCategoryDto>): RasterCategoryDto => r.body)
    );
  }

  /** Path part for operation `getRasterCategoriesFiltered()` */
  static readonly GetRasterCategoriesFilteredPath = '/v1/rastercategory/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRasterCategoriesFiltered()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getRasterCategoriesFiltered$Response(params: GetRasterCategoriesFiltered$Params, context?: HttpContext): Observable<StrictHttpResponse<PageRasterCategoryDto>> {
    return getRasterCategoriesFiltered(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRasterCategoriesFiltered$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getRasterCategoriesFiltered(params: GetRasterCategoriesFiltered$Params, context?: HttpContext): Observable<PageRasterCategoryDto> {
    return this.getRasterCategoriesFiltered$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageRasterCategoryDto>): PageRasterCategoryDto => r.body)
    );
  }

}
